import {useLocation} from "react-router-dom";
import {useTranslation, withTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import _ from "lodash";
import {Timeline} from "antd";

import comunidades from "../../../../_constants/comunidades";

function Tek1Bac(props) {
    const {t, i18n} = useTranslation();
    const [timelineData, setTimelineData] = useState([]);
    const {query, search} = useLocation();
    const year = +new URLSearchParams(search).get('year');

    const getPoints = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });
        if (mResult && mResult[0]){
            if (mResult[0].points === 999){
                return 999;
            }

        }
        return 0;
    }
    const getResponse = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]){
            if (mResult[0].assessment.questionType=== "COMAUT") {
                let mCom = _.filter(
                    comunidades, function (o) {
                        return o.code === mResult[0].points;
                    }
                );

                if (mCom && mCom[0]) return mCom[0].name;

                return "";
            }else if (mResult[0].assessment.questionType=== "MULTIPLE3" || mResult[0].assessment.questionType=== "MULTIPLE2" || mResult[0].assessment.questionType=== "MULTIPLE4") {
                let mText = mResult[0].subanswers.map(sub => sub.response.question).join(', ')

                return mText

            }else {
                if (mResult[0].response) {
                    return mResult[0]?.response?.question
                } else {
                    if (mResult[0].degree) {
                        return mResult[0]?.degree?.title
                    }else{
                        if (mResult[0].subject) {
                            return mResult[0]?.subject?.subject
                        }
                    }
                }
            }
        }else{
            return "";
        }
    }

    const getResponseSubject = (code, pos) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]){
          if (pos === 0){
              return mResult[0]?.subject?.subject
          }
            let order = _.orderBy(mResult[0]?.subanswers, ["subject.order"],['asc']);

            if (pos === 1){
                return order[0]?.subject?.subject + ", " +  order[1]?.subject?.subject
            }
            if (pos === 2){
                return order[2]?.subject?.subject
            }
        }else{
            return "";
        }
    }


    const getResponseModality = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]) {

            return mResult[0]?.subject?.modality


        } else {
            return "";
        }
    }

    useEffect(() => {
        let mTimeline =
        [
            { color: '#20388F',
                date:'20' + year + ' - 20' + (year+1),
                message: '<strong>' + t("tengo") + '</strong>: ' + getResponse(2) + '<br />'
                    + '<strong>' + t("tek.duranteeste") + '</strong>: ' + getResponse(5) + '<br /><br />'
                    + '<strong>' + t("tek.mbtx") + '</strong>: ' + getResponse(3) + '<br /><br />'
                    + '<strong>' + t("tek.satisfecho") + '</strong>: ' + getResponse(4) + '<br /><br />'
                    + '<strong>' + t("tek.promociono") + '</strong>: ' + getResponse(6) + '<br /><br />'
            },
            {  color: '#52C41A',
                date:'20' + (year+1) + ' - 20' + (year+2),
                message: '<strong>' + t("tek.segundob")  + '</strong><br /><br /><strong>' + t("tek.mitroncales") + '</strong>: ' + getResponseSubject(7,0) + '<br />'
                    +'<strong>' + t("tek.miespec") + '</strong>: ' + getResponseSubject(7,1) + '<br />'
                    +'<strong>' + t("tek.miopta") + '</strong>: ' + getResponseSubject(7,2) + '<br />'
                    +'<strong>' + t("tek.notamedia") + '</strong>: ' + getResponse(8) + '<br />'
                    +'<strong>' + t("tek.pruebaacc") + '</strong>: ' + getResponse(13) + '<br />'
            },
            {
                color: '#F5222D',
                date:'20' + (year+2) + ' - 20' + (year+3),
                message: '<strong>' + t("tek.encasobacn") + '</strong>: ' + getResponse(9) + '<br />' +
                    (getPoints(10) !== 999 ? '<strong>' + t("tek.mcfgs") + '</strong>: ' + getResponse(10) + '<br /><br />' : '<br /><br />') +
                    (getPoints(12) !== 999 ? '<strong>' + t("tek.miuni") + '</strong>: ' + getResponse(12) + '<br /><br />' : '<br /><br />') +
                    (getPoints(12) !== 999 ? '<strong>' + t("tek.estudiarenu") + '</strong>: ' + getResponse(14) + '<br /><br />' : '<br /><br />')
                    +'<strong>' + t("tek.estudiarenc") + '</strong>: ' + getResponse(15) + '<br /><br />'
            },
            { color: '#20388F',
                date:'20' + (year+3) + ' - 20' + (year+4),
                message:
                    (getPoints(10) !== 999 ? '<strong>' + t("tek.encasocfgs") + '</strong>: ' + getResponse(11) + '<br />' : '<br />')

            }
        ];
        props.setTimeline(mTimeline)

        setTimelineData(mTimeline)
    },[year])

    return (
        <>
            {!props.forDownload &&
            <Timeline mode={'left'}>
                {timelineData.map(item=><Timeline.Item   color={item.color} key={item.date} label={item.date}>
                        <p dangerouslySetInnerHTML={{__html: item.message}} />
                    </Timeline.Item>
                )}
            </Timeline>}
        </>
    );
}

export default withTranslation()(Tek1Bac);
